<template>
    <div class="shop-container" v-loading.fullscreen="loading">
        <swiper-small :list="bannerArr" v-if="!$route.query.id"/>
        <div class="article-left">
           <div class="jxdd" v-if="!$route.query.search_name">
                <div class="tabs">
                   <div class="item active" >{{$t('selectedReading')}}</div>
                </div>
                <div class="ad">
                    <router-link :to="{path: '/article/detail', query: {article_id: item.id}}" 
                    class="ad-item" v-for="item in homeList" :key="item.id">
													<!-- <img :src="item.cover" alt=""> -->
                        <div class="img-wrap" :style="{backgroundImage: `url(${item.cover})`, backgroundSize: 'cover'}"></div>
													<!-- <div class="img-wrap" :style="{backgroundImage: `url(${item.cover})`, backgroundSize: 'cover'}"></div> -->
                        <h3><div class="link">{{item.title}}</div></h3>
                    </router-link>
                </div>
            </div>

           <div class="rmtj">
               <div class="tabs">
                   <div class="item active" v-if="titleName">{{titleName}}</div>
                   <div class="item active" v-else-if="search_name">
                       <!-- 搜索结果 -->
                       {{$t('searchResult')}}
                    </div>
                   <div class="item active" v-else>{{$t('popularPosts')}}</div>
               </div>

               <div class="rmtj-list">
                   <div class="rmtj-list-item" v-for="item in dataList" :key="item.id">
                       <router-link :to="{path: '/article/detail', query: {article_id: item.id}}" >
                            <div class="img-link" :style="{backgroundImage: `url(${item.cover})`, backgroundSize: 'cover'}">
                                <!-- <img :src="item.cover" :alt="item.title"> -->
                            </div>
                            <div class="well">
                                <div class="title">{{item.title}}</div>
                                <div class="des">{{item.brief}}</div>
                            </div>
                       </router-link>
                       <div class="side">
                            <div class="tag">
                                <span>
                                    <router-link to="/" >{{item.type_name}}</router-link>
                                </span>
                            </div>
                            <div class="time">{{item.ctime}}</div>
                       </div>
                   </div>
               </div>
							 
							 <div class="nodata" v-if="!dataList.length">
								 No result for “<span class="search-name">{{$route.query.search_name}}</span>”  Found
							 </div>

                <Pagination
                    v-if="dataList.length>0"
                    :totalPage="totalPage"
                    :limit="limit"
                    @changePage="handleCurrentChange"
                ></Pagination>
            </div>
        </div>
		
        <div class="article-right">
            <div class="hot box">
                <h4>
                    <strong>{{$t('informationClassify')}}</strong>
                </h4>
                <ul>
                    <li v-for="item in classifyList.slice(0, classifyList.length - sliceNum)" :key="item.id" style="cursor: pointer"> <div @click="goClass(item)">{{item.type_name}}</div> </li>
                    <li class="more" @click="more" v-if="sliceNum != 0">{{$t('see')}}{{$t('more')}}</li>
                </ul>
            </div>
            <div class="choice box">
                 <h4>
                    <strong>{{$t('trendingToday')}}</strong>
                </h4>
                <ul class="article">
                    <template v-for="(item, index) in todayList">
                        <li  :key="index" v-if="index < todayLimit"> 
                            <em :class="{active: index < 3 }">{{index + 1}}</em>
                            <router-link  :to="{path: '/article/detail', query: {article_id: item.id}}" class="link">{{item.title}}</router-link>
                        </li>
                    </template>
                   
                    <li></li>
                </ul>
            </div>
            <div class="academy box" v-if="hot.length > 0"> 
                <h4>
                    <strong>{{$t('archeryInstitute')}}</strong>
                    <router-link to="/article/index" class="link">{{$t('more')}}></router-link>
                </h4>
                <ul>
                  <template v-for="(item, index) in hot">
                     <li v-if="index < 6" :key="item.id"> 
                        <div @click="reloadDetail(item.id)"  class="link">
                          <div class="palynums"> <span></span> 0</div>
                            <!-- <img :src="item.cover" alt=""> -->
                            <div class="img-wrap" :style="{backgroundImage: `url(${item.cover})`, backgroundSize: 'cover'}"></div>
                            <div class="title">{{item.title}}</div>
                        </div>
                    </li>
                  </template>
                </ul>
            </div>
        </div>

    </div>
</template>

<script>
import SwiperSmall from '@/components/common/SwiperSmall'
import Pagination from "@/components/common/Pagination.vue";

export default {
    inject: ['reload'],
    components: {
        SwiperSmall,
        Pagination
    },
    data() {
        return {
            activeName: 'jxdd',
            activeNameTj: 'tj',
            classifyList:[],
            sliceNum: 0,
            bannerArr: [],
            page: 1,
            limit: 10,
            id: '',
            initList: [], // 普通初始化数据
            dataList: [], // 热门列表
            todayList: [], // 今日推荐
            homeList: [], // 精选导读
            titleName: '',
            totalPage: 0,
            todayLimit: 10,
            search_name: '',
            where: {},
            hot: [],
            loading: false
        }
    },
    created() {
        console.log(this.$route)
        let id = this.$route.query.id || ''
        this.search_name = this.$route.query.search_name || ''
        if(id) {
            this.titleName = this.$route.query.name
            this.id = id
            this.init()
        } else if(this.search_name) {
            this.where.search_name = this.search_name
            this.init()
        } else {
            this.recommend() 
        }
        this.bannerList()
        this.classify()
        this.today()
        this.home()
        this.list('hot')
    },
    watch: {
        $route(v1, v2) {
            console.log('v1', v1)
            if(v1.query.id) {
            } else if(v1.query.search_name) {
                this.page = 1
								 this.search_name = v1.query.search_name
                this.where.search_name = this.search_name
                this.init()
            } else {
                this.titleName = ''
                this.recommend() 
            }
        }
    },
    methods:{
        reloadDetail(id) {
        this.$router.push({
          name: 'videodetail',
          params: {
            videoId: id
          }
        })
      },
         initParams() {
            let form =  {
                page: 1,
                limit: 10,
                where: {
                    is_hot: 1
                }
            }
            let copy = JSON.parse(JSON.stringify(form))
            copy.where = JSON.stringify(copy.where)
            return copy
        },
        list(value) {
            this.loading = true
            let params = this.initParams()
            this.$api.courseGetlist(params).then( res => {
                setTimeout(() =>{
                    this.loading = false
                }, 500)
                if(res.status) {
                    this[value] = res.data.list
                }
            })
        },
        handleCurrentChange(v) {
            this.page = v
            this.init()
        },
        // 今日推荐
        home() {
            let form = {
                where: JSON.stringify({is_home : 1})
            }
            this.$api.newgetlist(form).then(res => {
                if(res.status) {
                    this.homeList = res.data.list
                }
            })
        },
        // 今日推荐
        today() {
            let form = {
                where: JSON.stringify({is_rec : 1})
            }
            this.$api.newgetlist(form).then(res => {
                if(res.status) {
                    this.todayList = res.data.list
                }
            })
        },
        // // 热门推荐列表
        recommend() {
            let form = {
                limit: this.limit,
                where: JSON.stringify({is_hot: 1})
            }
            this.$api.newgetlist(form).then(res => {
                if(res.status) {
                    this.dataList = res.data.list
                    this.totalPage = Math.ceil(res.data.count / this.limit)
                }
            })
        },
        // 普通列表
        init() {
            let data = {
                page: this.page
            }
            if(this.search_name) {
                data.where = JSON.stringify(this.where)
            } 
            if(this.id) {
                data.type_id = this.id
            }
            this.$api.newgetlist(data).then(res => {
                if(res.status) {
                    this.dataList = res.data.list
                    this.totalPage = Math.ceil(res.data.count / this.limit)
                }
            })
        },
        goClass(item) {
            this.$router.push({
                path: '/article/index',
                query: {
                    id: item.id,
                    name: item.type_name
                }
            })
            this.page = 1
            this.reload()
        },
        classify() {
            this.$api.getnewstype().then(res => {
                if(res.status) {
                    this.classifyList = res.data.list
                }
            })
        },
        bannerList() {
            let data = {
                code: "pc_information_slide"
            };
            this.$api.slider(data).then(res => {
                if (res.status) {
                    this.bannerArr = res.data.list;
                }
            });
        },
        more() {
            this.sliceNum = 0
        }
    }
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/mixin.scss';
@import '@/assets/css/variable.scss';
    .link {
        position: relative;
    //   width: 125px;
      color: #595959;
      overflow: hidden;
      margin-right: 30px;
      margin-bottom: 10px;
      cursor: pointer;
      &:nth-child(4n) {
        margin-right: 0;
      }
      .title {
        overflow: hidden;
        word-break: break-all;
        word-wrap: break-word;
        height: 28px;
        @include no-wrap-line(2);
      }
      .img-wrap {
        position: relative;
        width: 190px;
        height: 114px;
        margin-bottom: 5px;
        overflow: hidden;
        img {
          width: 190px;
          height: 114px;
          display: block;
          margin: 0 0 12px;
          border-radius: 5px;
        }
      }
      .palynums {
        position: absolute;
        bottom: 45px;
        left: 0;
        width: 100%;
        color: #fff;
        font-size: 12px;
        z-index: 10;
        overflow: hidden;
        height: 20px;
        width: 100%;
        background: rgba(0,0,0,.3);
        display: flex;
        align-items: center;
        span {
          display: inline-block;
          overflow: hidden;
          width: 13px;
          height: 12px;
          margin-right: 3px;
          line-height: 999em;
          vertical-align: -2px;
          margin-left: 8px;
          background: url('http://www.sanlida.cn/Templates/master/sanlida/images/video_pic.png') no-repeat;
          background-size: 100% 100%;
        }
      }
      
    }
    .rmtj {
        &-list {
            &-item {
                position: relative;
                width: 100%;
                height: 130px;
                overflow: hidden;
                border-bottom: 1px solid #eee;
                padding: 21px 0;
                &:last-child {
                    border: none;
                }
                .side {
                    bottom: 21px;
                    width: 627px;
                    height: 24px;
                    box-sizing: border-box;
                    float: left;
                    font-size: 14px;
                    line-height: 24px;
                    color: #999;
                    .tag {
                        margin-right: 20px;
                        float: left;
                        span{
                            float: left;
                            margin: 0;
                        }
                    }
                }
                .img-link {
                    position: relative;
                    float: left;
                    width: 190px;
                    height: 127px;
                    overflow: hidden;
                    border-radius: 6px;
                    margin-right: 20px;
                    img {
                        display: block;
                        width: 100%;
                        height: 100%;
                    }
                }
                .well {
                        height: 100px;
                        .title {
                            height: 56px;
                            overflow: hidden;
                            font-size: 18px;
                            font-weight: 700;
                            line-height: 26px;
                            color: #333;
                            text-overflow: -o-ellipsis-lastline;
                            overflow: hidden; 
                            text-overflow: ellipsis; 
                            display: -webkit-box; 
                            -webkit-line-clamp: 2; 
                            line-clamp: 2; 
                            -webkit-box-orient: vertical;
                        }
                        .des {
                            height: 22px;
                            margin-top: 6px;
                            font-size: 16px;
                            line-height: 26px;
                            color: #595959;
                            @include no-wrap-line(2);
                        }
                }
            }
        }
    }
    .tabs {
        position: relative;
        &::after {
            content: "";
            position: absolute;
            left: 0;
            bottom: 0;
            width: 100%;
            height: 2px;
            background-color: #E4E7ED;
            z-index: 1;
        }
        .item {
            // padding: 0 20px;
            height: 40px;
            box-sizing: border-box;
            line-height: 40px;
            display: inline-block;
            list-style: none;
            font-size: 14px;
            font-weight: 500;
            color: #303133;
            position: relative;
            border-bottom: 2px solid #EA4B49;
            z-index: 2;
            &.active {
                color: #EA4B49;
            }
            &:first-child {
                padding-left: 0;
            }
        }
    }
    .article {
        &-left {
            width: 840px;
            float: left;
            background: #fff;
            border-radius: 6px;
            padding: 20px;
            margin-top: 20px;
            margin-bottom: 30px;
            .jxdd {
                width: 100%;
                // float: left;
                margin-bottom: 20px;
                overflow: hidden;
                .ad {
                    &-item {
                        float: left;
                        width: 264px;
                        margin-right: 20px;
                        border: 1px solid #eee;
                        margin-top: 20px;
                        box-sizing: border-box;
                        cursor: pointer;
                        &:nth-child(3n) {
                            margin-right: 0;
                        }
                        .img-wrap {
                            width: 264px;
                            height: 154px;
                        }
                        h3 {
                            height: 69px;
                            overflow: hidden;
                            padding: 10px 15px 15px 15px;
                            .link {
                                width: 100%;
                                height: 69px;
                                float: left;
                                line-height: 22px;
                                overflow: hidden;
                                font-size: 14px;
                                font-weight: normal;
                            }
                        }
                    }
                }
            }

        }
        &-right {
            width: 300px;
            float: right;
            border-radius: 6px;
            margin-top: 20px;
            font-size: 14px;
            .box {
                width: 260px;
                margin-bottom: 10px;
                padding: 0 20px;
                background: #fff;
                border-radius: 5px;
                h4 {
                    width: 300px;
                    margin-left: -20px;
                    height: 40px;
                    line-height: 40px;
                    border-bottom: 1px solid #e8e8e8;
                    border-radius: 5px 5px 0 0;
                    background: #ffffff;
                    background: linear-gradient(top, #ffffff, #f7f7f7);
                    strong {
                        display: block;
                        width: 122px;
                        margin-left: 15px;
                        color: #434a54;
                        font-weight: bold;
                        font-size: 14px;
                    }
                    .link {
                        float: right;
                        margin: -40px 20px 0 0;
                        color: #667ebd;
                        font-size: 12px;
                    }
                }
                &.hot {
                    overflow: hidden;
                    ul {
                        width: 302px;
                        margin-left: -20px;
                        overflow: auto;
                        li {
                            float: left;
                            width: 150px;
                            height: 45px;
                            line-height: 45px;
                            border-bottom: 1px solid #eee;
                            border-right: 1px solid #eee;
                            background: #ffffff;
                            text-align: center;
                            &:hover {
                                color: #EA4B49;
                            }
                            &.more {
                                width: 300px;
                                float: left;
                                height: 45px;
                                line-height: 45px;
                                border-bottom: 1px solid #eee;
                                border-right: 1px solid #eee;
                                background: #ffffff;
                                text-align: center;
                                cursor: pointer;
                            }
                        }
                    }
                }
                &.choice{
                    .article {
                        line-height: 24px;
                        margin: 0 0 0 24px;
                        padding: 10px 0;
                        li {
                            padding: 4px 0 5px;
                            em {
                                float: left;
                                width: 14px;
                                height: 14px;
                                line-height: 14px;
                                margin: 3px 0 0 -24px;
                                border: 2px solid #aab2bd;
                                border-radius: 50%;
                                color: #aab2bd;
                                font-family: Tahoma,Verdana,sans-serif;
                                font-size: 10px;
                                text-align: center;
                                &.active {
                                    border: 2px solid #ff6600;
                                    color: #ff6600;
                                }
                            }
                            .link {
								margin:0px;
                                color: #595959;
                                overflow: hidden;
								text-overflow: -o-ellipsis-lastline;
								overflow: hidden; 
								text-overflow: ellipsis; 
								display: -webkit-box; 
								-webkit-line-clamp: 3; 
								line-clamp: 3; 
								-webkit-box-orient: vertical
                            }
                        }
                    }
                }
                &.academy {
                    ul {
                        margin-top: 20px;
                        margin-left: -10px;
                        overflow: auto;
                        li {
                            float: left;
                            width: 125px;
                            height: 145px;
                            line-height: 18px;
                            margin-left: 10px;
                            .link {
                                color: #595959;
                                overflow: hidden;
                                width: 125px;
                                .img-wrap {
                                    width: 125px;
                                    height: 85px;
                                    display: block;
                                    // margin: 0 0 12px;
                                    border-radius: 5px;
                                }
                                .title {
                                    height: 40px;
                                }
                            }
                        }
                    }
                }
            }
        }
    }
		.nodata {
		  // height: 370px;
		  line-height: 40px;
		  margin-bottom: 10px;
		  padding-left: 14px;
		  font-weight: bold;
		  background: #ffffff;
		  // border: 1px solid #edd28b;
		  .search-name {
		    color: $theme-color;
		  }
		}	
</style>